<script>
/**
 * Descripción: pag HomeViewComponent
 *
 * @displayName HomeViewComponent
 */

export default {
  name: 'HomeViewComponent',

  methods: {
    goBlog() {
      this.$router.push('/Blog');
    }
  }
};
</script>

<template>
  <section id="hero">
    <v-row no-gutters>
      <v-img
        :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
        :src="require('@/assets/app/home.png')"
        loading="lazy"
      >
        <v-theme-provider dark>
          <v-container fill-height>
            <v-row align="center" class="white--text mx-auto" justify="center">
              <v-col class="white--text text-center" cols="12" tag="h1">
                <center>
                  <v-img
                    :src="require('@/assets/logos/complete.svg')"
                    loading="lazy"
                    max-width="930"
                  />
                </center>
              </v-col>
              <v-btn class="align-self-end" fab outlined @click="goBlog()">
                <v-icon>mdi-chevron-double-down</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-theme-provider>
      </v-img>
    </v-row>
  </section>
</template>
